package game.entity

import game.*
import kotlin.random.Random

class Nessy(val spriteId: String, val animationSpriteId: String, val projectileSpriteId: String, val targetTile: TileType, hp: Int, damage: Int) :
    Enemy(hp, damage) {
    enum class State {
        Emerging,
        Attacking,
        Digging,
        Moving,
    }

    var coolDown = 0
    var moveCounter = 0
    var state = State.values()[Random.nextInt(State.values().size)]

    override fun onInit(game: Game, room: Room) {

    }

    override fun onTick(game: Game, room: Room) {
        if (coolDown > 0) {
            coolDown--
        } else {
            when (state) {
                State.Emerging -> {
                    sprite = game.getSpriteById(animationSpriteId)
                    coolDown = sprite!!.duration
                    state = State.Attacking
                }
                State.Attacking -> {
                    val projectile = Projectile(0.2, damage)
                    projectile.startAttack(game, col, row, game.player.col, game.player.row, projectileSpriteId)
                    room.addEntity(projectile)
                    sprite = game.getSpriteById(spriteId)
                    coolDown = 75
                    state = State.Digging
                }
                State.Digging -> {
                    sprite = game.getSpriteById(animationSpriteId)
                    coolDown = sprite!!.duration
                    state = State.Moving
                    moveCounter = Random.nextInt(25,35)
                }
                State.Moving -> {
                    sprite = null
                    var destCol = col
                    var destRow = row
                    when (Random.nextInt(4)) {
                        0 -> destCol = col - 1
                        1 -> destCol = col + 1
                        2 -> destRow = row - 1
                        3 -> destRow = row + 1
                    }
                    if (destCol in 0 until ROOM_WIDTH && destRow in 0 until ROOM_HEIGHT && room[destCol, destRow].type == targetTile) {
                        col = destCol
                        row = destRow
                    }

                    coolDown = 2

                    if (moveCounter > 0) {
                        moveCounter--
                    } else {
                        state = State.Emerging
                    }
                }
            }
        }
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        if (state == State.Attacking) {
           return super.onCollideWithPlayer(game, room)
        } else {
            return true
        }
    }
}